import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=1310ed26&scoped=true"
import script from "./Info.ts?vue&type=script&lang=ts&external"
export * from "./Info.ts?vue&type=script&lang=ts&external"
import style0 from "./Info.vue?vue&type=style&index=0&id=1310ed26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1310ed26",
  null
  
)

export default component.exports